import { render, staticRenderFns } from "./marketIp.vue?vue&type=template&id=f839601a&scoped=true"
import script from "./marketIp.vue?vue&type=script&lang=js"
export * from "./marketIp.vue?vue&type=script&lang=js"
import style0 from "./marketIp.vue?vue&type=style&index=0&id=f839601a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f839601a",
  null
  
)

export default component.exports